import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { DeportePage } from './pages/DeportePage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
function useHashRoute() {
  const [hash, setHash] = useState(window.location.hash || '#/');
  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash || '#/');
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return hash;
}
export function App() {
  const route = useHashRoute();
  // Initialize Meta Pixel once on mount
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  // Fire PageView on route change
  useEffect(() => {
    trackPageView();
  }, [route]);
  if (route === '#/deporte') {
    return <DeportePage data-id="element-0" />;
  }
  return <div className="min-h-screen bg-warm-bg font-body text-warm-dark" data-id="element-1">
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <FailedAttempts data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <WhoIsFor data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <ProofSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <OfferSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}